function is_int(value){
  if((parseFloat(value) == parseInt(value)) && !isNaN(value)){
      return true;
  } else {
      return false;
  }
}

function isNumber(n){
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function valide_date(value) {
  var gooddate = new RegExp("^\[0-9]{2}\/[0-9]{2}\/[0-9]{4}$");
  return gooddate.test(value);
}

function valide_mail(mail){
    var reg = new RegExp('^[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*@[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*[\.]{1}[a-z]{2,6}$', 'i');
    if(reg.test(mail)){
        return(true);
    }
    else{
        return(false);
    }
}

function prix_formate(prix)
  {
  prix = Math.round(prix*100)/100;
  dec = prix - Math.round(prix);
  if(dec==0)
    return prix + '.00';
  else
    {
    dec2 =  Math.round(100*dec)/10
    //alert(dec2);
    dec = dec2 - Math.round(dec2);
    //alert(prix+'->'+dec)
      if(dec==0)
        return prix + '0';
      else
        return prix+'';
    }
  }

function envoi_courriel(str1,str2,str3,str4){
    if(str4)
        return "mailto:"+str1+"@"+str2+"."+str3+"?"+str4;
    else
        return "mailto:"+str1+"@"+str2+"."+str3;
}

function MM_openBrWindow(theURL,winName,features){ //v2.0
  window.open(theURL,winName,features);
}